export default __webpack_public_path__ + "static/Fellix-Regular-9875082b9f74b067ca5272fd526e9f94.woff2";